module.exports = __webpack_public_path__ + "img/第8章_4-2_賴和館電鈴.jpg";